export * from './product-subtext.component';
